module.exports = __webpack_public_path__ + "static/media/Vamp2.63e8d290.png";